export function registerAdminPwa() {
  if (!("serviceWorker" in navigator) || import.meta.env.DEV) return;
  void navigator.serviceWorker.register("/sw.js").catch(() => undefined);
}
